import { render, staticRenderFns } from "./NewFilters.vue?vue&type=template&id=fda1df6a&"
import script from "./NewFilters.vue?vue&type=script&lang=ts&"
export * from "./NewFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports